var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0140CD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 10c.552 0 1 .45 1 1.006v2.51c0 1.196-.619 2.082-1.73 2.437-.098.031-.2.047-.303.047H2.033c-.103 0-.205-.016-.303-.047C.619 15.598 0 14.713 0 13.516v-2.51C0 10.45.448 10 1 10c.553 0 1 .45 1 1.006v2.51c0 .276 0 .493.504.493H13.57c.394 0 .427-.182.43-.425v-2.578c0-.556.448-1.006 1-1.006zM9 0c.552 0 1 .439 1 .98V6h1.996c.647 0 .994.871.565 1.345l-4 4.408c-.299.33-.823.33-1.122 0l-4-4.408C3.01 6.871 3.354 6 4.002 6H6V.98C6 .439 6.448 0 7 0h2z",
    transform: "translate(-509 -334) translate(24 235) translate(0 44) matrix(1 0 0 -1 485 71)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cea315349afcda67781b7e1f24b1f074.svg";
export { ForwardRef as ReactComponent };